import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, Ref, computed } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { DetailsSidebar } from '@/modules/transaction/components/DetailsSidebar';
import { TermsSignature } from '@/modules/common/components/TermsSignature';

import {
  IInvestmentReview,
  IDetails,
  ITermSignature,
  termSignature
} from '@/modules/transaction/services/product-investment';

import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { isImpersonate } from '@/modules/common/services/partner';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import InstrumentAvatar from '@/modules/trade/components/InstrumentAvatar/InstrumentAvatar.vue';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const investmentReview = inject('investmentReview') as Ref<IInvestmentReview>;
const termSignatureData = inject('termSignatureData') as Ref<ITermSignature>;
const isFetchingInvestment = inject('isFetchingInvestment') as Ref<boolean>;
const makeInvestment = inject('makeInvestment') as (
  useBaseAsset: boolean
) => Promise<void>;
const useBaseAssetChoice = inject('useBaseAssetChoice') as Ref<boolean>;

const isLoading = ref(false);
const isTermSignatureOpen = ref(false);
const isDetailsOpen = ref(false);
const sidebarDetails = ref<IDetails>({
  title: '',
  description: '',
  button: null
});

const route = useRoute();
const productType = computed(() => {
  const { type } = route.params;
  return type;
});

const useBaseAsset = computed(() => {
  return useBaseAssetChoice.value;
});

function openDetails(details: IDetails | null) {
  if (!details) return;

  sidebarDetails.value = details;
  isDetailsOpen.value = true;
}

function handleClick() {
  if (
    termSignatureData.value.requestTermsSignature.length > 0 &&
    !isImpersonate()
  ) {
    isTermSignatureOpen.value = true;
    return;
  }

  makeInvestment(useBaseAsset.value);
}

async function acceptTerms() {
  isTermSignatureOpen.value = false;

  try {
    isLoading.value = true;

    await termSignature(
      termSignatureData.value.requestTermsSignature[0].productId,
      productType.value
    );
    makeInvestment(useBaseAsset.value);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,investmentReview, termSignatureData, isFetchingInvestment, makeInvestment, useBaseAssetChoice, isLoading, isTermSignatureOpen, isDetailsOpen, sidebarDetails, route, productType, useBaseAsset, openDetails, handleClick, acceptTerms, HeadingDisplay, ContentDisplay, Heading, ListDisplay, ButtonContainer, ButtonPrimary, BaseText, DetailsSidebar, TermsSignature, NebraskaColors, InstrumentAvatar }
}

})